<template>
  <!-- record -->
  <div class="receipt" style="font-family: '微软雅黑';">
    <template v-if="medicineChinese != 0">
      <div class="page" v-for="(item, index) in record.patientChineseDrugList" :id='scriptInfo(index)' :key="item.prescription + 'info'">
        <!-- 处方信息 -->
        <div style="font-size: 8pt; line-height: 16pt;">
          <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
          <div style="float: right;">
            <p style="float: right;">
              <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
            </p>
            <p
              style="width:24pt;float: right; text-align:center;height: 14pt;line-height: 14pt;border:1pt solid rgba(51,51,51,1);border-radius:4px;display: inline-block;margin-right: 8pt;">
              普通</p>
          </div>
        </div>
        <div style="clear: both;"></div>
        <h3 style="text-align: center; font-size: 16pt;margin-top: 0;font-family: '微软雅黑';font-weight: normal;">
          {{ printConfig.titleName || $store.state.global.countInfo.hospitalName }}</h3>
        <h4 style="text-align: center; font-size: 12pt;margin-top: -12pt;font-family: '微软雅黑';font-weight: normal;">饮片处方笺&nbsp;({{ index + 1}})
        </h4>
        <div class="user-info" style="font-size: 9pt;margin-top: -8pt;font-family: '微软雅黑';">
          <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
            <div style="display: inline-block;width: 33.333%; float: left;">
              姓名：{{ record.patient.patientName }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              年龄：
              <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
              <span v-else>
                <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
                <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
                  record.patient.month }}月</span>
                <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
              </span>
            </div>
          </div>
          <div style="border-bottom: 1pt solid #999;; line-height: 24pt;height: 24pt;">
            <div style="display: inline-block;width: 33.333%; float: left;">
              手机号：{{ record.patient.phoneNo }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              科室：{{ record.inquiryInfo.laboratoryName }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
              就诊日期：{{ record.inquiryInfo.clinicalTime }}
            </div>
            <div style="display: inline-block;width: 33.333%; float: left;">
            </div>
          </div>
          <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
            <div>
              临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
            </div>
          </div>
          <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
            <div>
              过敏史：{{ record.inquiryInfo.allergyHistory }}
            </div>
          </div>
        </div>
        <!-- 字母 -->
        <div style="line-height:10pt;">
          <h1 style="font-size: 16pt;display: inline-block;font-family:DFPSongW7;float:left;">R</h1>
          <h2 style="font-size: 12pt;display: inline-block;font-family:DFPSongW7;float:left;">p</h2>
        </div>
        <div style="clear: both;"></div>
      </div>
      <!-- 处方 -->
      <div class="page" v-for="(item, index) in record.patientChineseDrugList" :id='idAdd(index)'
        :key="item.prescription">
        <!-- 成药处方 -->
        <TABLE border=0 cellSpacing=0 cellPadding=1 width="100%"
          style="border-collapse:collapse;font-size: 9pt;font-family: '微软雅黑';">
          <TBODY>
            <TR>
              <td style="border-bottom: 1pt dashed rgba(170,170,170,1);line-height:0.8;margin-top: 2pt;">
                <div style="width: 48%; float:left;margin-right: 2%; margin-bottom: 5pt; display: flex;flex-shrink: 0;"
                     v-for="(it, index) in 2" :key="index">
                  <div style="width: 38%;">药名</div>
                  <div style="width: 28%;">用量</div>
                  <div style="width: 28%;">总量</div>
                  <div style="width: 28%;">备注</div>
                </div>
              </td>
            </TR>
            <TR>
              <TD>
                <div style="width: 48%; float:left;margin-right: 2%;height: 10pt;margin-top: 3pt;margin-bottom: 4pt;"
                  v-for="(it, index) in item.patientChineseDrugPiecesList" :key="index + item.prescription">
                  <span style="width: 27%;display: inline-block;height: 2pt">{{ it.drugName }}</span> &nbsp;
                  <span style="width: 22%;display: inline-block;height: 2pt">{{ it.value }} {{ it.unit }}</span>
                  <span style="width: 20%;display: inline-block;height: 2pt">{{ it.value * item.totalDosage || 0 }} {{ it.unit }}</span>&nbsp;
                  <span style="width: 20%;display: inline-block;height: 2pt" v-if="it.comment">({{ it.comment }})</span>
                </div>
              </TD>
            </TR>
            <TR>
              <TD>
                <div style="border-top: 1pt dashed rgba(170,170,170,1);line-height:0.8;margin-top: 2pt;">
                  <!--<h3 style="display: inline-block;float:left;">共{{ item.totalDosage }}剂</h3>-->
                  <p style="display: inline-block;float:left;">用法：{{ item.usage }}, {{ item.frequency }}, 共{{ item.totalDosage }}剂</p>
                </div>
                <div style="clear: both;"></div>
                <div style="line-height:0.8;">备注：{{ item.dailyDosage }}</div>
              </TD>
            </TR>
          </TBODY>
        </TABLE>
      </div>
      <!-- 诊所信息 -->
      <div style="margin-top: 0px;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-pieces">
        <div style="font-size: 9pt;border-bottom: 1pt solid #999;; line-height: 24pt;height:24pt;font-family: '微软雅黑';">
          <div style="float: left; width: 49%;">
            医生：<span v-if="printConfig.printDoctorName == 1">{{ record.realName }}</span>
          </div>
          <div style="float: right; width: 49%;text-align: center;">
            金额：<span v-show="printConfig.printTotalPrice == 1">￥<span id="piecesTotalSum0"></span></span>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div style="font-size: 9pt;border-bottom: 1pt solid #999;; line-height: 24pt;height:24pt;font-family: '微软雅黑';">
          <div style="float: left; width: 24.5%;">
            审查：
          </div>
          <div style="float: left; width: 24.5%;">
            调配：
          </div>
          <div style="float: left; width: 24.5%;">
            核对：
          </div>
          <div style="float: left; width: 24.5%;">
            发药：
          </div>
        </div>
        <div style="clear: both;"></div>
        <div style="font-size: 9pt;line-height: 24pt;font-family: '微软雅黑';">
          注：{{ printConfig.remark }}
        </div>
      </div>
    </template>

    <template v-else>
      <div class="page" v-for="(item, index) in record.patientChineseDrugList" :id='scriptInfo(index)'
           :key="item.prescription + 'info'">
        <!-- 处方信息 -->
        <div style="font-size: 8pt; line-height: 16pt;">
          <p style="float: left;">.{{ record.inquiryInfo.recordId }}</p>
          <div style="float: right;">
            <p style="float: right;">
              <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
            </p>
            <p
                style="width:24pt;float: right; text-align:center;height: 14pt;line-height: 14pt;border:1pt solid rgba(51,51,51,1);border-radius:4px;display: inline-block;margin-right: 8pt;">
              普通</p>
          </div>
        </div>
        <div style="clear: both;"></div>
        <h3 style="text-align: center; font-size: 16pt;margin-top: 0;font-family: '微软雅黑';font-weight: normal;">
          {{ printConfig.titleName || $store.state.global.countInfo.hospitalName }}</h3>
        <h4 style="text-align: center; font-size: 12pt;margin-top: -12pt;font-family: '微软雅黑';font-weight: normal;">{{ item.type == 2 ? '饮片' : '复方颗粒' }}处方笺&nbsp;({{index + 1}})
        </h4>
        <div class="user-info" style="font-size: 10pt;margin-top: -8pt;font-family: '微软雅黑';">
          <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
            <div style="display: inline-block;width: 25%; float: left;">
              姓名：{{ record.patient.patientName }}
            </div>
            <div style="display: inline-block;width: 25%; float: left;">
              性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
            </div>

            <div style="display: inline-block;width: 25%; float: left;">
              出生日期：{{ record.patient.birthday }}
            </div>
            <div style="display: inline-block;width: 25%; float: left;">
              就诊日期：{{ record.inquiryInfo.clinicalTime }}
            </div>
          </div>
          <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
            <div>
              临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
            </div>
          </div>
          <!-- 字母 -->
          <div style="display: flex;justify-content: space-between;font-size: 10pt;line-height: 2;margin-bottom: 5pt;">
            <div style="display: inline-block;">RP</div>
            <div style="display: inline-block;">
              剂数：{{ item.totalDosage }}
              剂 &nbsp;&nbsp; 用法：{{ item.usage }}
              &nbsp;&nbsp; 代煎：{{ item.isProcess == 1 ? `是(￥${priceIndex1(index)})` : '否' }}
            </div>
          </div>
          <!-- 成药处方标题 -->
          <div style="width: 31%; float:left;margin-right: 2%; margin-bottom: 5pt; display: flex;flex-shrink: 0;"
               v-for="(it, index) in 3" :key="index + item.prescription">
            <div style="width: 50%;">品名</div>
            <!--<div style="width: 35%;">{{ item.type == 2 ? '规格' : '当量' }}</div>-->
            <div style="width: 35%;">剂量</div>
            <div style="width: 35%;">数量</div>
            <div style="width: 35%;">备注</div>
          </div>
        </div>
      </div>
      <!-- 处方 -->
      <div class="page" v-for="(item, index) in record.patientChineseDrugList" :id='idAdd(index)'
           :key="item.prescription">
        <!-- 成药处方 -->
        <table border=0 cellSpacing=0 cellPadding=1 width="100%"
               style="border-collapse:collapse;font-size: 10pt;font-family: '微软雅黑';">
          <tbody>
          <tr>
            <td>
              <div style="width: 31%; float:left;margin-right: 2%; margin-bottom: 5pt; display: flex;flex-shrink: 0;"
                   v-for="(it, index) in item.patientChineseDrugPiecesList" :key="index + item.prescription">
                <!--{{it}}-->
                <div style="width: 50%;">{{ it.drugName.replace('配方颗粒', '') }}</div>
                <!--<div style="width: 35%;">{{ it.specification }}</div>-->
                <div style="width: 35%;">{{ it.value }} </div>
                <!--<div style="width: 35%;"> {{ it.value * item.totalDosage }}{{ it.unit }}{{ it.comment ? '('+it.comment+')' : ''}}</div>-->
                <div style="width: 35%;"> {{ it.value * item.totalDosage }}{{ it.unit }}</div>
                <div style="width: 35%;">{{ it.comment }}</div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!-- 诊所信息 -->
      <div style="margin-top: 0px;font-size: 9pt;font-family: '微软雅黑';width: 100%;" id="footer-info-pieces">
        <div
            style="font-size: 9pt;border-bottom: 1pt solid #999;border-top: 1pt solid #999; line-height: 24pt;width: 100%;height:24pt;font-family: '微软雅黑'; display: flex;">
          <div style="width: 16.66%;flex-shrink: 0;">
            医生：<span v-if="printConfig.printDoctorName == 1">{{ record.realName }}</span>
          </div>
          <div style="width: 16.66%;flex-shrink: 0;">
            审查：
          </div>
          <div style="width: 16.66%;flex-shrink: 0;">
            调配：
          </div>
          <div style="width: 16.66%;flex-shrink: 0;">
            核对：
          </div>
          <div style="width: 16.66%;flex-shrink: 0;">
            发药：
          </div>
          <div style="width: 16.66%;flex-shrink: 0;">
            <!-- prescriptionAmt -->
            金额：<span v-show="printConfig.printTotalPrice == 1">￥<span id="piecesTotalSum1"></span></span>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </template>
  </div>

</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { BigNumber } from 'bignumber.js';
import { printTemplate, printTemplateA5 } from './print'

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  /**
   *  type 的几种类型
   *  medicine -> 成药
   *  pieces -> 饮片
   *  infusion -> 输液
   *  apply -> 服帖
   *  infusionCard -> 输液卡
   *  other -> 其他
  */
  props: {
    record: {
      type: Object,
      default: {},
    },
    isReview: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      medicineChinese: 1,
      printTime: '',
      curType: 'pieces',
    }
  },
  methods: {
    print ({ isReview, index } = {}) {
      this.newPrint()
      // if (this.medicineChinese != 0) {
      //   this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      //   const { scriptValue } = this.$store.state.global.printConfig;
      //   this.$nextTick(() => {
      //     const LODOP = getLodop();
      //     LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
      //     LODOP.PRINT_INIT('处方打印');
      //     LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '处方');
      //     console.log(this.record, "9999999999999999999999")
      //     this.record.patientChineseDrugList.forEach((item, index) => {
      //       LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById(`${this.curType}-info` + index).innerHTML);
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem1);",  //ljj加的 跟随链接
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //
      //       LODOP.ADD_PRINT_HTM('75mm', '5%', '90%', '110mm', document.getElementById(this.curType + index).innerHTML);
      //
      //       document.getElementById('piecesTotalSum0').innerText = this.priceIndex(index)
      //       LODOP.ADD_PRINT_HTM('155mm', '5%', '90%', '50mm', document.getElementById('footer-info-pieces').innerHTML);
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //       LODOP.NewPageA();
      //     });
      //     LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
      //     LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
      //     LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
      //     LODOP.SET_PRINTER_INDEX(scriptValue);
      //     // LODOP.PREVIEW();
      //     if (isReview) {
      //       LODOP.PREVIEW();
      //     } else {
      //       LODOP.PRINT();
      //     }
      //   });
      // } else {
      //   this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      //   const { scriptValue ,index} = this.$store.state.global.printConfig;
      //   this.$nextTick(() => {
      //     console.log(this.record.patientChineseDrugList, 'record.patientChineseDrugList')
      //     const LODOP = getLodop();
      //     LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
      //     LODOP.PRINT_INIT('处方打印');
      //     LODOP.SET_PRINT_PAGESIZE(1, '210mm', '140mm', );
      //     this.record.patientChineseDrugList && this.record.patientChineseDrugList.forEach((item, index) => {
      //       //页眉
      //       LODOP.ADD_PRINT_HTM(0, '5%', '90%', '100mm', document.getElementById(`${this.curType}-info` + index).innerHTML);
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);  //参数1代表固定每页输出上述内容(页眉 页尾)
      //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //
      //       // 内容
      //       const a = document.getElementById(this.curType + index)
      //       LODOP.ADD_PRINT_HTM('62mm', '5%', '90%', '78mm', a.innerHTML);
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);  //参数1代表固定每页输出上述内容(页眉 页尾)
      //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //
      //       // 页尾
      //       document.getElementById('piecesTotalSum1').innerText = this.priceIndex(index)
      //       LODOP.ADD_PRINT_HTM('110mm', '5%', '90%', '140mm', document.getElementById('footer-info-pieces').innerHTML);
      //       // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接)
      //       LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //
      //       if (index < this.record.patientChineseDrugList.length - 1) {
      //         LODOP.NewPageA();
      //       }
      //
      //       // if (LODOP.NewPageA()) {
      //       //   LODOP.ADD_PRINT_HTM(0, '5%', '90%', '100mm', document.getElementById(`${this.curType}-info` + index).innerHTML);
      //       //   LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);  //参数1代表固定每页输出上述内容(页眉 页尾)
      //       //   // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接
      //       //   LODOP.SET_PRINT_STYLEA(0, "VOrient", 3);
      //       //
      //       //   document.getElementById('piecesTotalSum1').innerText = this.priceIndex(index)
      //       //   LODOP.ADD_PRINT_HTM('110mm', '5%', '90%', '140mm', document.getElementById('footer-info-pieces').innerHTML);
      //       //   LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
      //       //   // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接)
      //       //   LODOP.SET_PRINT_STYLEA(0, "VOrient", 3);
      //       // }
      //     });
      //
      //     LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
      //     LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
      //     LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
      //     LODOP.SET_PRINTER_INDEX(scriptValue);
      //     // LODOP.PREVIEW();
      //     // if (isReview) {
      //     LODOP.PREVIEW();
      //     // } else {
      //     //   LODOP.PRINT();
      //     // }
      //   });
      //
      //
      //   // this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      //   // const { scriptValue ,index} = this.$store.state.global.printConfig;
      //   // this.$nextTick(() => {
      //   //   const LODOP = getLodop();
      //   //   LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
      //   //   LODOP.PRINT_INIT('处方打印');
      //   //   LODOP.SET_PRINT_PAGESIZE(1, '210mm', '140mm', );
      //   //   this.record.patientChineseDrugList.forEach((item, index) => {
      //   //     //页眉
      //   //     LODOP.ADD_PRINT_HTM(0, '5%', '90%', '100mm', document.getElementById(`${this.curType}-info` + index).innerHTML);
      //   //     LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);  //参数1代表固定每页输出上述内容(页眉 页尾)
      //   //     // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接
      //   //     LODOP.SET_PRINT_STYLEA(0, "VOrient", 3);
      //   //     // 内容
      //   //     const a = document.getElementById(this.curType + index)
      //   //     LODOP.ADD_PRINT_HTM('48mm', '5%', '90%', '90mm', a.innerHTML);
      //   //     LODOP.SET_PRINT_STYLEA(0, "ItemType", 0);  //参数1代表固定每页输出上述内容(页眉 页尾)
      //   //     LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //   //
      //   //     // 页尾
      //   //     document.getElementById('piecesTotalSum1').innerText = this.priceIndex(index)
      //   //     LODOP.ADD_PRINT_HTM('110mm', '5%', '90%', '140mm', document.getElementById('footer-info-pieces').innerHTML);
      //   //     LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
      //   //     // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 3);//ljj加的跟随链接)
      //   //     LODOP.SET_PRINT_STYLEA(0, "VOrient", 3);
      //   //
      //   //     if (LODOP.NewPageA()) {
      //   //       LODOP.ADD_PRINT_HTM(0, '5%', '90%', '100mm', document.getElementById(`${this.curType}-info` + index).innerHTML);
      //   //       LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);  //参数1代表固定每页输出上述内容(页眉 页尾)
      //   //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接
      //   //       LODOP.SET_PRINT_STYLEA(0, "VOrient", 3);
      //   //
      //   //       document.getElementById('piecesTotalSum1').innerText = this.priceIndex(index)
      //   //       LODOP.ADD_PRINT_HTM('110mm', '5%', '90%', '140mm', document.getElementById('footer-info-pieces').innerHTML);
      //   //       LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
      //   //       // LODOP.SET_PRINT_STYLEA(0, "linkedItem", 1);//ljj加的跟随链接)
      //   //       LODOP.SET_PRINT_STYLEA(0, "VOrient", 3);
      //   //     }
      //   //   });
      //   //
      //   //   LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
      //   //   LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
      //   //   LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
      //   //   LODOP.SET_PRINTER_INDEX(scriptValue);
      //   //   // LODOP.PREVIEW();
      //   //   // if (isReview) {
      //   //     LODOP.PREVIEW();
      //   //   // } else {
      //   //   //   LODOP.PRINT();
      //   //   // }
      //   // });
      // }
    },

    // 获取中药处方模板
    async getMedicineChinese () {
      let res = await this.$api.clinicManagement.getHospitalConfig({ configType: 16, })
      this.medicineChinese = res.medicineChinese
    },

    // 计算金额
    drugAmt (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取打印配置
    getPrintConfig () {
      this.$api.clinicManagement.getPrintConfit({ configType: 6 }).then((res) => {
        this.printConfig = res;
      })
    },
    scriptInfo (index) {
      return `${this.curType}-info` + index;
    },
    idAdd (index) {
      return this.curType + index
    },
    // 药品单项合计金额-返回0
    drugAmtSub (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return 0;
      return BN(price).multipliedBy(num).toFixed(2);
    },
    priceIndex(index) {
      if (!this.record.patientChineseDrugList || this.record.patientChineseDrugList.length === 0) return 0;
      let sum = 0
      let patientChineseDrug = this.record.patientChineseDrugList[index]
      let patientChineseDrugPieces = patientChineseDrug.patientChineseDrugPiecesList.reduce((c, d) => {
        const salePrice = Number(d.univalence);
        const dosage = Number(d.value);
        return c + Number(this.drugAmtSub(salePrice, dosage));
      }, 0);
      const totalDosage = Number(patientChineseDrug.totalDosage) || 1; // 剂量
      sum = (patientChineseDrugPieces * totalDosage).toFixed(2)
      console.log('sum',sum)
      return sum
    },
    priceIndex1(index) {
      return this.record.patientChineseDrugList[index].prescribeProcItemDto.totalPrice || 0
    },
    // 打印处方  新
    newPrint() {
      // console.log(this.record, 'this.record')
      // patientChineseDrugList

      const LODOP = getLodop();
      let title = {
        company: this.printConfig.titleName || this.$store.state.global.countInfo.hospitalName,
        type: '饮片处方笺',
        ...this.record.inquiryInfo,
        ...this.record.patient,
        ...this.printConfig,
        realName: this.record.realName,
        sex: this.record.patient.gender == -1 ? '未知' : (this.record.patient.gender == 0 ? '女' : '男'),
      }
      let oldList = JSON.parse(JSON.stringify(this.record.patientChineseDrugList))
      let chineseNum = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']

      let list = oldList.reduce((prev, item, index) => {
        item.printTypeTitle = item.type == 2 ? `饮片处方笺(${chineseNum[index]})` : `复方颗粒处方笺(${chineseNum[index]})`
        item.proxyFried = oldList[index].prescribeProcItemDto.totalPrice || 0
        item.amount = this.priceIndex(index)

        let splitArrNum = this.medicineChinese != 0 ? 24 : item.type == 2 ? 21 :14

        for (let i = 0; i < item.patientChineseDrugPiecesList.length; i += splitArrNum) {
          const chunk = item.patientChineseDrugPiecesList.slice(i, i + splitArrNum);
          prev.push({...item, patientChineseDrugPiecesList: chunk});
        }

        return prev
      }, [])

      if (this.medicineChinese != 0) {
        for (let i = 0; i < list.length; i++) {
          printTemplateA5(title, list[i], LODOP)
          LODOP.NewPage()
        }
      } else {
        for (let i = 0; i < list.length; i++) {
          printTemplate(title, list[i], LODOP)
          LODOP.NewPage()
        }
      }

      LODOP.PREVIEW()
    }
  },
  computed: {
    laboratoryName () {
      return this.$store.state.global.countInfo.laboratoryName;
    },
    prescriptionAmt () {
      if (!this.record.patientChineseDrugList || this.record.patientChineseDrugList.length === 0) return '';
      const subPatientChineseDrugList = this.record.patientChineseDrugList.reduce((a, b) => {
        const sub = b.patientChineseDrugPiecesList.reduce((c, d) => {
          const salePrice = Number(d.univalence);
          const dosage = Number(d.value);
          return c + Number(this.drugAmtSub(salePrice, dosage));
        }, 0);
        const totalDosage = Number(b.totalDosage) || 1; // 剂量
        const results = BN(sub).multipliedBy(Number(totalDosage));
        return a + Number(results);
      }, 0);
      return BN(subPatientChineseDrugList).toFixed(2);
    },
    totalPrice () {
      return this.record.patientChineseDrugList.reduce((a, b) => {
        return a + b.prescribeProcItemDto.totalPrice;
      }, 0).toFixed(2);
    },
  },
  watch: {
    record(newValue) {
      // console.log('父组件传过来的值有点慢')
    }
  },
  mounted () {
    this.getPrintConfig();
    this.getMedicineChinese()
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2px solid #000000;
}

.receipt {
  width: 300px;
  justify-content: space-between;
}

span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1pt solid #000000;
  z-index: 100;
  width: 1000px;
  background: white;
  left: -5000px;
  top: 100px;
}
</style>
